import apiRequest from "../apiRequest";

const getNavigationData = async () => {
  const token = process.env.NEXT_PUBLIC_API_TOKEN;
  try {
    const response = await apiRequest.get(`menus?populate=*`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getDetailNavigationData = async (url) => {
  const token = process.env.NEXT_PUBLIC_API_TOKEN;
  try {
    const response = await apiRequest.get(`menus?filters[url_menu][$eq]=${url}&populate=*`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getFooterData = async () => {
  const token = process.env.NEXT_PUBLIC_API_TOKEN;
  try {
    const response = await apiRequest.get(`footer?populate=*`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getSubMenuData = async (filter="") => {
  const token = process.env.NEXT_PUBLIC_API_TOKEN;
  try {
    const response = await apiRequest.get(`sub-menus${filter}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export { getNavigationData, getFooterData, getSubMenuData, getDetailNavigationData };
